export const SET_REGISTER_SERVICE = 'register/SET_REGISTER_SERVICE';
export const POST_REGISTER_SERVICE = 'saga/register/POST_REGISTER_SERVICE';
export const SET_REGISTER_RRSS = 'register/SET_REGISTER_RRSS';
export const POST_REGISTER_RRSS = 'register/POST_REGISTER_RRSS';
